/* Storefront guard only; Shopify checkout validation is a separate admin/app capability. */
(() => {
  'use strict';
  const handles=new Set(['strawberry-banana-protein-smoothie','chocolate-peanut-butter-banana-protein-smoothie','vanilla-berry-protein-smoothie','pineapple-berry-protein-smoothie']);
  let checking=false, allowed=false;
  const base=window.Shopify?.routes?.root || '/';
  async function removeSmoothiesAndCheckout(button) {
    if(checking)return;
    checking=true;button.disabled=true;
    const original=button.textContent;
    let notice=button.parentElement.querySelector('[data-sp-removal-error]');
    if(!notice){notice=document.createElement('p');notice.dataset.spRemovalError='';notice.setAttribute('role','alert');button.after(notice);}
    notice.hidden=true;button.textContent='Updating your cart…';
    async function cartRequest(path,body){
      const response=await fetch(base+path,body?{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}:{cache:'no-store',headers:{Accept:'application/json'}});
      const data=await response.json();
      if(!response.ok || data.status>=400)throw new Error(data.description || 'Could not update your cart. Please try again.');
      return data;
    }
    try{
      const before=await cartRequest('cart.js');
      const smoothies=before.items.filter(item=>handles.has(item.handle));
      if(!before.items.some(item=>!handles.has(item.handle)))throw new Error('There are no remaining products to check out.');
      const quantity=smoothies.reduce((sum,item)=>sum+item.quantity,0);
      if(quantity>=10)throw new Error('Your smoothie box is now complete. Review your cart before checking out.');
      // Keep the incomplete box as a local draft before excluding it from collagen checkout.
      // It is restored only when this browser returns to the smoothie builder.
      if(smoothies.length){
        const draft={items:smoothies.map(item=>({id:item.variant_id || item.id,quantity:item.quantity,...(item.properties && Object.keys(item.properties).length?{properties:item.properties}:{}),...(item.selling_plan_allocation?.selling_plan?.id?{selling_plan:item.selling_plan_allocation.selling_plan.id}:{})}))};
        try{localStorage.setItem('spb-unfinished-box-v1',JSON.stringify(draft));}
        catch(_){throw new Error('Your browser could not save your unfinished box. Please allow site storage and try again.');}
      }
      // Checkout excludes only the incomplete smoothie lines. Never clear or rebuild the cart.
      if(smoothies.length)await cartRequest('cart/update.js',{updates:Object.fromEntries(smoothies.map(item=>[item.key,0]))});
      const after=await cartRequest('cart.js');
      if(after.items.some(item=>handles.has(item.handle)))throw new Error('Your cart changed. Please review it and try again.');
      if(!after.items.length)throw new Error('Your cart is empty. Please add a product before checkout.');
      allowed=true;window.location.assign(base+'checkout');
    }catch(error){
      notice.textContent=error.message;notice.hidden=false;
      document.dispatchEvent(new CustomEvent('sp:cart-updated'));
    }finally{checking=false;button.disabled=false;button.textContent=original;}
  }
  async function validate(event) {
    if(allowed)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(checking)return;checking=true;
    try {
      const response=await fetch(base+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Could not check your cart. Please try again.');
      const cart=await response.json();
      const qty=cart.items.filter(i=>handles.has(i.handle)).reduce((sum,i)=>sum+i.quantity,0);
      if(qty>22){
        window.alert('Your box holds up to 22 smoothies. Please reduce the quantity before checkout.');
        window.location.assign(base+'cart');
      } else if(qty>0 && qty<10){
        window.alert(`Please add ${10-qty} more smoothie${10-qty===1?'':'s'} to reach the 10-smoothie minimum.`);
        window.location.assign(base+'pages/subscription');
      } else {allowed=true;window.location.assign(base+'checkout');}
    }catch(e){window.alert(e.message);}finally{checking=false;}
  }
  window.addEventListener('pageshow',()=>{allowed=false;checking=false;});
  document.addEventListener('click',event=>{
    const removal=event.target.closest('[data-sp-remove-smoothies]');
    if(removal){event.preventDefault();event.stopImmediatePropagation();if(!removal.disabled)removeSmoothiesAndCheckout(removal);return;}
    const control=event.target.closest('button[name="checkout"],input[name="checkout"],a[href]');
    if(!control || control.disabled)return;
    if(control.matches('[name="checkout"]'))validate(event);
    else if(new URL(control.href,location.href).pathname.replace(/\/$/,'')===(base+'checkout').replace(/\/$/,''))validate(event);
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(form instanceof HTMLFormElement && /\/cart\/?$/.test(new URL(form.action,location.href).pathname) && event.submitter?.name==='checkout')validate(event);
  },true);
})();
